/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as FilterClear } from '../../assets/svg/filter-clear.svg';
export default FilterClear;
